/**
 * Custom item renderer for product type dropdown showing name + description only
 * @param {Object} option - The option object with name and description
 * @returns {JSX.Element} Rendered item with name and description
 */
export const renderProductTypeOption = (option) => {
  if (!option) {
    return null
  }
  
  return (
    <div className="flex flex-col">
      <span className="font-medium text-admin_text">
        {option.name}
      </span>

      {option.description && (
        <span className="text-sm text-admin_text_secondary">
          {option.description}
        </span>
      )}
    </div>
  )
}

/**
 * Simple renderer for selected value showing just the name
 * @param {Object} option - The option object
 * @returns {string} Just the name for selected value
 */
export const renderProductTypeSelectedValue = (option) => {
  if (!option) {
    return ""
  }
  
  return option.name
}

export default renderProductTypeOption